import { connect } from 'react-redux';

import { State as StoreState } from 'store/state';

import Component from './component';
import { Props } from './types';

const mapStateToProps = (state: StoreState, ownProps?: Props): object => {
    return {
        state: {
            authToken: state.user.authToken,
            company: state?.user?.profile?.company,
        },
    };
};


Component.defaultProps = {};
export default connect(mapStateToProps, null)(Component);